export const lqip = (el: HTMLImageElement, dataUri: string) => {
	el.classList.add('lqip', 'blur');
	el.style.backgroundImage = `url(${dataUri})`;
	el.addEventListener('load', () => {
		el.classList.remove('blur');
	});
};
